const ADMIN_AUTH_KEY = "nextera_admin_auth_v2";
const LEGACY_SESSION_KEY = "nextera_admin_session_v1";

const isClient = typeof window !== "undefined";

function decodeJwtPayload(token) {
  try {
    const payload = token.split(".")[1];
    if (!payload) {
      return null;
    }

    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = atob(normalized);
    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
}

function isTokenValid(token) {
  if (!token) {
    return false;
  }

  const payload = decodeJwtPayload(token);
  if (!payload?.exp) {
    return false;
  }

  const expiresAt = payload.exp * 1000;
  return expiresAt > Date.now() + 15_000;
}

export function setAdminSession({ token, admin }) {
  if (!isClient || !token) {
    return;
  }

  const payload = decodeJwtPayload(token);
  const expiresAt = payload?.exp ? payload.exp * 1000 : null;

  window.localStorage.setItem(
    ADMIN_AUTH_KEY,
    JSON.stringify({
      token,
      admin: admin || null,
      expiresAt,
      loggedInAt: new Date().toISOString()
    })
  );

  window.sessionStorage.removeItem(LEGACY_SESSION_KEY);
}

export function getAdminSession() {
  if (!isClient) {
    return null;
  }

  const raw = window.localStorage.getItem(ADMIN_AUTH_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !isTokenValid(parsed.token)) {
      clearAdminSession();
      return null;
    }

    return parsed;
  } catch (error) {
    clearAdminSession();
    return null;
  }
}

export function getAdminAccessToken() {
  return getAdminSession()?.token || "";
}

export function clearAdminSession() {
  if (!isClient) {
    return;
  }

  window.localStorage.removeItem(ADMIN_AUTH_KEY);
  window.sessionStorage.removeItem(LEGACY_SESSION_KEY);
}

export function isAdminAuthenticated() {
  return Boolean(getAdminSession()?.token);
}
